const removeTypeName = (value) => {
	if (value === null || value === undefined) {
		return value;
	} else if (Array.isArray(value)) {
		return value.map((v) => removeTypeName(v));
	} else if (typeof value === 'object') {
		const newObj = {};
		Object.entries(value).forEach(([key, v]) => {
			if (key !== '__typename') {
				newObj[key] = removeTypeName(v);
			}
		});
		return newObj;
	}
	return value;
};

export const removeByType = (value, condition = (v) => typeof v !== 'undefined') => {
	if (Array.isArray(value)) {
		return value.map((v) => removeByType(v, condition));
	} else if (Object.prototype.toString.call(value) === '[object Object]') {
		const newObj = {};
		Object.entries(value).forEach(([key, v]) => {
			if (condition(v)) {
				newObj[key] = removeByType(v, condition);
			}
		});
		return newObj;
	}
	return value;
};

export const removeFalsyErrors = (value) => {
	if (value === null || value === undefined) {
		return value;
	} else if (Array.isArray(value)) {
		return value.map((v) => removeFalsyErrors(v));
	} else if (typeof value === 'object') {
		const newObj = {};
		Object.entries(value).forEach(([key, v]) => {
			if (!!v && !isFalsyArray(v)) newObj[key] = removeFalsyErrors(v);
		});
		return Object.keys(newObj).length ? newObj : null;
	}
	return value;
};

const isFalsy = (value) => Number.isInteger(value) && value < 1;

const isFalsyArray = (array) => array.every(isFalsy);

export default removeTypeName;
